import { compareOrder } from '@genially/commons';

import type { GeniallyContent } from '../../types/GeniallyContent';
import { findPopupParentSlideForGeniallyContent } from '../interactivities/findPopupParent';

export const sortActivitiesBySlideOrder = (geniallyData: GeniallyContent) => {
  const sortedSlidesIds = geniallyData.slides
    .filter(slide => !slide.Popup)
    .slice()
    .sort((slideA, slideB) => compareOrder(slideA, slideB))
    .map(slide => slide.Id);

  geniallyData.slides
    .filter(slide => slide.Popup)
    .forEach(slide => {
      const parentSlide = findPopupParentSlideForGeniallyContent(slide, geniallyData);

      if (parentSlide) {
        const parentSlideIndex = sortedSlidesIds.indexOf(parentSlide.Id);

        sortedSlidesIds.splice(parentSlideIndex, 0, slide.Id);
      } else {
        sortedSlidesIds.push(slide.Id);
      }
    });

  const sortedActivities = geniallyData.activities
    .slice()
    .sort(
      (activityA, activityB) =>
        sortedSlidesIds.indexOf(activityA.IdSlide) -
        sortedSlidesIds.indexOf(activityB.IdSlide),
    );

  return sortedActivities;
};
